import { Field, FieldProps } from 'formik';
import { Form, Checkbox, Label } from 'semantic-ui-react';

interface AuthCheckboxProps {
    name: string;
    label: string;
    formProps?: any;
}

export const AuthCheckbox: React.FC<AuthCheckboxProps> = ({
    name,
    label,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form, meta }: FieldProps) => (
                <Form.Field error={meta.touched && !!meta.error}>
                    <Checkbox
                        id={name}
                        name={name}
                        label={label}
                        checked={field.value || false}
                        onChange={(e, { checked }) => form.setFieldValue(name, checked)}
                    />
                    {meta.touched && meta.error && (
                        <Label basic color="red" pointing>
                            {meta.error}
                        </Label>
                    )}
                </Form.Field>
            )}
        </Field>
    );
};